document.addEventListener('DOMContentLoaded', () => {

    const zoomModal = document.querySelector('.js-gallery-modal')
    const repairModal = document.querySelector('.js-repair-modal')

    document.body.addEventListener('click', function (e) {
        closeModalOnSideClick(e, zoomModal, 'is-active')
        closeModalOnSideClick(e, repairModal, 'is-active')
    })

    document.body.addEventListener('keydown', function (e) {
        if (e.key === "Escape") {
            closeModalOnEscape(zoomModal, 'is-active')
            closeModalOnEscape(repairModal, 'is-active')
        }
    })

    function closeModalOnSideClick(clickEvent, modal, classToRemove) {
        const clickedTarget = clickEvent.target

        if (modal !== null && clickedTarget.classList.contains(classToRemove)) {
            modal.classList.remove('is-active')
            document.body.classList.remove('no-scroll')
            document.documentElement.classList.remove('no-scroll')
        }
    }

    function closeModalOnEscape(modal, classToRemove) {
        if (modal !== null && modal.classList.contains(classToRemove)) {
            modal.classList.remove('is-active')
            document.body.classList.remove('no-scroll')
            document.documentElement.classList.remove('no-scroll')
        }
    }

})
